import { Alert } from "types/alert";
import { formatUnixTimestampToDate } from "utils/formatters";
import { convertAlertToText } from "./convert-alert-to-text";
import { FieldsBible } from "types/holy-books";
import { Geofence } from "types/geofence";
import { formatLatLongToDMS } from "utils/converters";

export interface FormattedAlert {
  text: string;
  coordinates: string;
  triggerTime: string;
  triggerTimestamp: string;
  severity: string;
  sources: string[];
}

export const formatAlert = (
  alert: Alert,
  fieldsBible: FieldsBible | null,
  geofences: Geofence[]
): FormattedAlert => {
  const text = convertAlertToText(alert, fieldsBible, geofences, false);
  const coordinates = formatLatLongToDMS(
    alert?.coordinates?.lat,
    alert?.coordinates?.lon
  );
  const triggerTime = formatUnixTimestampToDate(alert?.trigger_time);
  const triggerTimestamp = alert?.trigger_time;
  const severity = alert?.info?.rule?.severity || "critical";
  const sources = getSourceFromAlertInfo(alert, fieldsBible);

  return {
    text,
    coordinates,
    triggerTime,
    triggerTimestamp,
    severity,
    sources,
  };
};

const getSourceFromAlertInfo = (
  alert: Alert,
  fieldsBible: FieldsBible | null
) => {
  if (alert.type === "threshold" && "fields" in alert.info) {
    return alert.info.fields
      .filter((field) => field?.device?.name)
      .map((field) => {
        const device = field?.device;
        const fieldLabel = fieldsBible?.[field?.name]?.label || field?.name;

        return `${fieldLabel}: ${device?.name} ${
          device?.instance !== null && device?.instance !== undefined
            ? `#${device.instance + 1}`
            : ""
        }`;
      });
  }
  if (alert.type === "external" && "device" in alert.info) {
    const device = alert.info.device;
    if (device?.name) {
      return [
        `${device?.name} ${
          device?.instance !== null && device?.instance !== undefined
            ? `#${device.instance + 1}`
            : ""
        }`,
      ];
    }
  }
  return [];
};
